import React from 'react';
import { Navigate } from 'react-router';
import { useIsAdmin } from 'hooks/useIsAdmin';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface Props {
  children: React.ReactNode;
}

const AdminRoute = ({ children }: Props) => {
  // In cookie mode, check for user data instead of token
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = token || user;
  const { isAdmin } = useIsAdmin();

  if (!isAuthenticated) {
    return <Navigate to="/welcome" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/my-cards" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;